import React from 'react'
import aImg from '../../images/about/img-1.png'

const About = (props) => {
    return (

        <section className="tf-about-section section-padding">
            <div className="container">
                <div className="tf-about-wrap">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="tf-about-img">
                                <img src={aImg} alt="" />
                                <div className="tf-about-img-text">
                                    <div className="tf-about-icon">
                                        <h3>20+</h3>
                                        <span>Years Exprience</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="tf-about-text">
                                <small>About Me</small>
                                <h2>Welcome to Edsberger&nbsp;Consulting</h2>

                                <h5>With over 20 years of experience in software development and leadership, I bring both technical expertise and a passion for 
                                  helping others grow. </h5>

                                <p>I love coding, sharing knowledge (presenting on stage!), and breaking down complex ideas in a way that’s easy to understand. People tell me this 
                                  combination is pretty rare, so if you’re looking for someone who can both build and explain things clearly, you’re in the right place!</p>

                                <p>I’ve worked with clients of all sizes, from startups to large enterprises, helping them create successful software products. 
                                  My core expertise is in computer graphics and high-performance computing (the field I specialized in during my Ph.D.), 
                                  but my skills and interests extend far beyond that.</p>

                                <p>Not sure if I can help with your specific project or challenge? Feel free to reach out using the contact form below and 
                                  if you’re nearby, the coffee is on me!</p>

                                {/*
                                <div className="tf-funfact">
                                    <div className="tf-funfact-item">
                                        <h3><span>C</span>++</h3>
                                        <p>Enjoyer</p>
                                    </div>
                                    <div className="tf-funfact-item">
                                        <h3><span>52</span>+</h3>
                                        <p>Awards Win</p>
                                    </div>
                                    <div className="tf-funfact-item">
                                        <h3><span>2</span>M+</h3>
                                        <p>Happy clients</p>
                                    </div>
                                </div>
                                */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="visible-rotate-text">
                <h1>About Me</h1>
            </div>
        </section>
    )
}

export default About;